export const API_KEY = "AIzaSyDS7IYLTbgcVn4WysKn0wtS8hixbUst_-Y";


export default API_KEY;